export default value => {
  if (!value) {
    return null
  }
  const date = new Date(value)
  return date.toLocaleTimeString('et-ee', {
    hour: '2-digit',
    minute: '2-digit'
  })
}
